import queryString from 'query-string'

export const { parse } = queryString
